"use client";

import { MotionConfig } from "motion/react";

/**
 * The single app-wide `MotionConfig` mount (D-28).
 *
 * WHY IT IS A SEPARATE FILE. `src/app/layout.tsx` is a Server Component and
 * `MotionConfig` is a Client Component, so the config cannot be written inline
 * in the layout. This wrapper exists for that reason and does nothing else.
 *
 * WHAT `reducedMotion="user"` ACTUALLY BUYS, stated so nobody over-reads it.
 * It is necessary and nowhere near sufficient. Motion applies it by consulting
 * a fixed list of positional keys (x, y, width, top, ...) and setting those
 * instantly instead of animating them. A reveal built from opacity, blur,
 * clip path or background colour runs at FULL STRENGTH underneath it, and the
 * app-wide `@media (prefers-reduced-motion: reduce)` rule in globals.css
 * cannot reach any of it either, because Motion routes these values through
 * WAAPI `Element.animate()` and that rule governs CSS animations and
 * transitions only.
 *
 * So this is the floor, not the fix. Per-animation variant swapping on an
 * explicit boolean is the fix, and `src/components/ui/animated-text.tsx` plus
 * `src/hooks/useReducedMotionSafe.ts` are where it lives.
 *
 * Mounted exactly once, in `src/app/layout.tsx` inside `ConsentProvider`.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
    return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
